import type { ModelListProps } from "./model-list.type";

import { List, Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";

import { ModelLink } from "@/modules/model-link";

export const ModelList = ({ model, items, withLink }: ModelListProps) => {
  const { t } = useTranslation();

  if (!items?.length) return <></>;

  if (items.length === 1) {
    return withLink ? (
      <ModelLink model={model} item={items[0]} />
    ) : (
      items[0].name
    );
  }

  const length = items.length - 1;
  const text = `${items[0].name} ${t("global:and")} ${length} ${t(
    "global:otherPlural"
  )}`;

  return (
    <Tooltip
      color="#fff"
      placement="bottom"
      title={
        <List
          size="small"
          dataSource={items}
          renderItem={(item) => {
            return (
              <List.Item>
                {withLink ? <ModelLink model={model} item={item} /> : item.name}
              </List.Item>
            );
          }}
        />
      }
    >
      <Typography.Text>{text}</Typography.Text>
    </Tooltip>
  );
};
